import { createApp } from 'vue';
import FlacToWavConverter from '@/Components/FlacToWavConverter.vue';
import '@styles/app.css';

createApp(FlacToWavConverter).mount('#flac-to-wav-converter');
